import React from 'react';
import { Modal } from '../../ui/common/Modal';

export interface SlackRealtimeInfoModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const SlackRealtimeInfoModal: React.FC<SlackRealtimeInfoModalProps> = ({
  isOpen,
  onClose,
}) => (
  <Modal
    isOpen={isOpen}
    onClose={onClose}
    title="Mensajes de Slack en tiempo real"
    description="La conexión de Slack usa un token de usuario. El tiempo real es una configuración adicional."
    size="lg"
    footer={
      <button
        type="button"
        onClick={onClose}
        style={{
          padding: '9px 14px',
          borderRadius: 8,
          border: '1px solid var(--z-border)',
          background: 'transparent',
          color: 'var(--z-text)',
          cursor: 'pointer',
        }}
      >
        Entendido
      </button>
    }
  >
    <div
      style={{ display: 'grid', gap: 16, color: 'var(--z-text)', lineHeight: 1.5, fontSize: 14 }}
    >
      <p style={{ margin: 0 }}>
        <strong>Conexión con token de usuario:</strong> permite leer y enviar mensajes que tu
        usuario puede ver, probar la conexión y usar el polling de Zunelo. Pega un token{' '}
        <code>xoxp-…</code> en la configuración principal de Slack.
      </p>
      <p style={{ margin: 0 }}>
        <strong>Tiempo real completo:</strong> Slack requiere una app instalada/autorizada con
        Events API. Para canales privados, el bot también necesita acceso al canal. Esta opción
        puede recibir eventos sin esperar el siguiente polling.
      </p>
      <div
        style={{
          padding: 14,
          borderRadius: 10,
          background: 'var(--z-fill)',
          border: '1px solid var(--z-border)',
        }}
      >
        <strong>Para activar el modo tiempo real completo</strong>
        <ol style={{ margin: '8px 0 0', paddingLeft: 22 }}>
          <li>Crea o configura una Slack App con bot user.</li>
          <li>Activa Event Subscriptions.</li>
          <li>
            Usa como Request URL: <code>https://zunelo.web.app/api/slack/events</code>.
          </li>
          <li>
            Suscríbela a <code>message.channels</code>, <code>message.groups</code>,{' '}
            <code>message.im</code> y <code>message.mpim</code>.
          </li>
          <li>
            Autoriza la app en el workspace y permite al bot entrar a los canales privados que deban
            emitir eventos.
          </li>
        </ol>
      </div>
      <p style={{ margin: 0, color: 'var(--z-dim)' }}>
        La conexión con token de usuario funciona sin activar Events API. Zunelo sincroniza mediante
        polling; el modo tiempo real es opcional.
      </p>
    </div>
  </Modal>
);
